import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'SignEntityType/Combo', method: 'GET', token: token })
}
